module.exports = __webpack_public_path__ + "static/img/horizontal_logo2.0d2a59a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/horizontal_logo2.png
// module id = 7lPY
// module chunks = 30